<template>
  <div>
    <head>
      <meta charset="utf-8" />
      <title>Stichting Mara</title>
      <meta content="width=device-width, initial-scale=1" name="viewport" />

      <link href="@/assets/images/favicon.ico" rel="shortcut icon" type="image/x-icon" />
      <link href="@/assets/images/webclip.png" rel="apple-touch-icon" />
    </head>
    <body>
      <div class="donaties-grid">
        <div class="page-link">
          <div class="body-block">
            <template v-if="!showAllCities">
              <template v-if="store.page.index != 4">
                <Header :page_id="current_page" @goBack="previousPage" />
              </template>
              <router-view />
            </template>
            <template v-else>
              <ChooseCityFullPage :city_name="city" @chooseCity="chooseCity" />
            </template>
          </div>

          <div v-if="store.page.index != 4" class="footer-part">
            <div v-if="error" class="error">
              {{ error_message }}
            </div>
            <div class="footer-block">
              <ChooseCity
                :city="city"
                :isSelected="showAllCities"
                @update="setCityChoose"
              />
              <div @click="nextPage" class="donation-button w-button">
                {{ button }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </body>
  </div>
</template>

<script>
import Header from "@/components/Header.vue"
import ChooseCity from "@/components/ChooseCity.vue"
import ChooseCityFullPage from "@/components/ChooseCityFullPage.vue"

import routerCheck from "@/router/goToNextPage"

export default {
  name: "App",
  components: {
    Header,
    ChooseCity,
    ChooseCityFullPage,
  },
  created() {
    this.$router.push({ name: this.current_page })
  },

  data: () => {
    return {
      showAllCities: false,
      city: "Landelijk bestuur",
      button: "Volgende stap",
      current_page: "step1",
      error: false,
      error_message: "Ho! Zorg ervoor dat je alle gegevens goed invult!",
    }
  },
  computed: {
    store: function () {
      return this.$store.state
    },
  },
  methods: {
    setCityChoose() {
      this.showAllCities = !this.showAllCities
    },

    chooseCity(city) {
      this.city = city
      this.setCityChoose()
    },

    async nextPage() {
      if (routerCheck.goToNextPage()) {
        this.error = false
        this.current_page = this.store.page.path[this.store.page.index - 1].name

        if (
          this.store.page.index ==
          this.store.page.path[this.store.page.path.length - 2].page
        ) {
          this.button = "Doneren"
        }

        if (this.store.page.index == 3) {
          const url = await this.createAPiRequest()
          if (url) {
            window.open(url, "_blank")
            this.$router.push({ name: "done" })
            return
          }
        }
        this.$router.push({ name: this.store.page.path[this.store.page.index].name })
      } else {
        this.error = true
      }
    },
    previousPage() {
      let index = this.store.page.index

      this.button = "Volgende stap"

      if (index < 1) {
        this.$router.push({ name: this.store.page.path[0].name })
        return
      }
      this.$router.push({ name: this.store.page.path[index - 2].name })
    },
    async createAPiRequest() {
      const data = {
        apiToken: process.env.VUE_APP_API_TOKEN,
        city: this.city,
        amount: this.$store.state.payment_info.amount,
        metadata: {
          email: this.$store.state.user_info.email,
          voornaam: this.$store.state.user_info.firstname,
          achternaam: this.$store.state.user_info.lastname,
          terugkerend: this.store.payment_info.type_payment,
          type_customer: this.$store.state.user_info.type_customer,
          streetname: this.$store.state.user_info.streetname | null,
          housenumber: this.$store.state.user_info.housenumber | null,
          postalcode: this.$store.state.user_info.postalcode | null,
          city: this.$store.state.user_info.city | null,
          birthday: this.$store.state.user_info.birthday | null,
        },
        method: this.$store.state.payment_info.payment_option,
      }

      var response = await this.axios.post(
        "https://marapaymentbackend.netlify.app/.netlify/functions/index/createpayment",
        data,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      )
      return response.data.paymentUrl
    },
  },
}
</script>

<style>
@import "assets/css/normalize.css";
@import "assets/css/webflow.css";
@import "assets/css/style.css";
@import "assets/css/extra.css";
</style>
